window.onerrorCpt = 0;
window.onerror    = function (errorMsg, url, lineNumber, column, errorObj) {
	if (window.onerrorCpt < 2) {
		let message = {message: ('Error: ' + errorMsg + ' Script: ' + url + ' Line: ' + lineNumber + ' Column: ' + column + ' StackTrace: ' + errorObj)};
		let ajax   = new XMLHttpRequest();
		let params = Object.keys({message}).map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(message[k])).join('&');
		ajax.open('POST',  "/php/script/errorJs.php", true);
		ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		ajax.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=UTF-8");
		ajax.send(params);
	}
	window.onerrorCpt++;
};
class SiteClient extends VLW.Site{
	constructor(){
		super();
		this.isLibraryGalerieLoaded = false;
		window.addEventListener('scroll', this.onScroll);
	}

	libraryGalerieLoaded(){
		this.isLibraryGalerieLoaded = true;
		broadCaster.GALELOADED.dispatch();
	}
	intro          () {
		TweenLite.set(document.body, {autoAlpha: 1});
		new VLW.IntroBureau();
		this.onIntroComplete();
	}
	onLoadStart    () {
		if (document.querySelector(".body-loader")) {
			TweenMax.to(document.querySelector(".body-loader"), 3, {opacity: 1, right: "0%", startAt: {left: 0, opacity: 0, right: "100%"}, yoyo: false, repeat: 999});
		}
	}
	onLoadComplete () {
		if (document.querySelector(".body-loader")) {
			TweenMax.killTweensOf(document.querySelector(".body-loader"));
			var tl = new TimelineMax();
			tl.add(TweenMax.to(document.querySelector(".body-loader"), .5, {right: "0%", opacity: 1}));
			tl.add(TweenMax.to(document.querySelector(".body-loader"), .5, {left: "100%"}));
		}
	}
}
window.siteClient = new SiteClient();


window.promiseIntro       = new Promise((resolve, reject) => {
	window.promiseIntroResolve = resolve;
	
});

if ( typeof window.GMAP_API !== "undefined" && window.GMAP_API!="") {
	let loadGMAP   = document.createElement('script');
	loadGMAP.type  = 'text/javascript';
	loadGMAP.async = 1;
	loadGMAP.src   = '//maps.google.com/maps/api/js?callback=onGmapLoaded&key=' + GMAP_API;
	(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(loadGMAP);
	window.onGmapLoaded = ()=> {
		broadCaster.GMAPLOADED.dispatch();
	};
}
